<ng-container *ngIf="{status: status$ | async, loads: loads$ |async} as tmpState">
  <app-dashboard-card [title]="title" [confined]="true" [padding]="true">
    <ng-container cardHeaderRight>
      <cwc-tags design-version="v2" selectable>
        <cwc-tag design-version="v2"
          [ngStyle]="{'pointer-events': activeTab.length === 1 && (activeTab | includes: Tabs.Active) ? 'none' : 'inherit'}"
          (cwcSelected)="onTabChanged($event.detail, Tabs.Active); " [name]="Tabs.Active"
          id="cmx-dashboard-loads-tag-active" [selected]="activeTab | includes: Tabs.Active">
          {{ tabName(Tabs.Active) }}
        </cwc-tag>
        <cwc-tag design-version="v2"
          [ngStyle]="{'pointer-events': activeTab.length === 1 && (activeTab | includes: Tabs.Completed) ? 'none' : 'inherit'}"
          (cwcSelected)=" onTabChanged($event.detail, Tabs.Completed);" [name]="Tabs.Completed"
          id="cmx-dashboard-loads-tag-complete" [selected]="activeTab | includes: Tabs.Completed">
          {{ tabName(Tabs.Completed) }}
        </cwc-tag>
        <cwc-tag design-version="v2" [ngClass]="{
            'cwc-tag-disabled': isPlannedDisabled$ | async
          }"
          [ngStyle]="{'pointer-events': activeTab.length === 1 && (activeTab | includes: Tabs.Planned) ? 'none' : 'inherit'}"
          (cwcSelected)=" onTabChanged($event.detail, Tabs.Planned);" [name]="Tabs.Planned"
          id="cmx-dashboard-loads-tag-planned" [selected]="activeTab | includes: Tabs.Planned">
          {{ tabName(Tabs.Planned) }}
        </cwc-tag>
      </cwc-tags>
    </ng-container>

    <div cardBody class="loads-content">
      <ng-container *ngIf="(tmpState.status) !== (Status.PENDING || Status.NOJOBSITES); else loadingState">
        <ng-container *ngIf="(tmpState.status) !== Status.NOJOBSITES; else noJobsites">
          <cwc-table-wrapper *ngIf="tmpState.loads.length > 0; else emptyResult" class="loads-table">
            <table class="data">
              <thead>
                <tr>
                  <th>{{ columnLabel(0) }}</th>
                  <th>{{ columnLabel(6) }}</th>
                  <th *ngIf="currentJobsiteId === 'ALL'">{{ columnLabel(7) }}</th>
                  <th>{{ columnLabel(1) }}</th>
                  <th>{{ columnLabel(2) }}</th>
                  <th>{{ columnLabel(3) }}</th>
                  <ng-container *ngIf="extended">
                    <th>{{ columnLabel(4) }}</th>
                    <th>{{ columnLabel(5) }}</th>
                  </ng-container>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                  let load of tmpState.loads;
                  trackBy: ('orderId' | cwcTrackBy)
                " attr.data-testid="load-row-{{ load.orderId }}">
                  <td class="order-col">
                    <cwc-button *ngIf="load.groupStatus === Tabs.Active" (cwcClick)="goToTrack(load)"
                      variant="link">{{load.orderCode}}</cwc-button>
                    <ng-container *ngIf="load.groupStatus !== Tabs.Active">{{load.orderCode}}</ng-container>
                  </td>
                  <td>{{ load.order.programedDateTime | cmxDateMoment}}</td>
                  <td *ngIf="currentJobsiteId === 'ALL'">{{ load.jobsiteDesc }}</td>
                  <td>{{ load.load }}</td>
                  <td class="no-wrap">{{ load.volume }}</td>
                  <td class="product-ellipses">
                    <ng-container *ngIf="load.products?.length > 1; else single">
                      <cwc-popover variant="select" design-version="v2">
                        <span [ngClass]="{
                          'col-active': load.products?.length > 1
                        }" slot="target">
                          {{ load.products.length }}&nbsp;{{ productsLabel }}
                        </span>
                        <div slot="content">
                          <ng-container *ngTemplateOutlet="
                            productsTable;
                            context: { products: load.products }
                          "></ng-container>
                        </div>
                      </cwc-popover>
                    </ng-container>
                    <ng-template #single>
                      <span *ngIf="load.products">
                        {{ load.products[0]?.productDesc || '—' }}
                      </span>
                    </ng-template>
                  </td>
                  <ng-container *ngIf="extended">
                    <td class="word-break">{{ load.purchaseOrder }}</td>
                    <td class="ellipses" title="{{ load.instructionsDesc }}">{{ load.instructionsDesc }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </cwc-table-wrapper>
          <ng-template #emptyResult>
            <cwc-empty-result [header]='emptyListText' icon="information-rounded-fill" variant="flat">
              {{ emptyListDescription }}
            </cwc-empty-result>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #loadingState>
        <div class="loader-wrapper"><cwc-loader size="medium"></cwc-loader></div>
      </ng-template>
      <ng-template #noJobsites>
        <cwc-empty-result icon="information-rounded-fill" variant="flat">
          {{ emptyMessage }}
        </cwc-empty-result>
      </ng-template>
    </div>
  </app-dashboard-card>

  <ng-template #productsTable let-products="products">
    <table class="products-table">
      <thead>
        <tr>
          <th>{{ productsTableLabels[0] }}</th>
          <th class="align-right">{{ productsTableLabels[1] }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of products">
          <tr>
            <td>{{ product.productDesc }}</td>
            <td class="align-right no-wrap">{{ product.value + ' ' + product.unitDesc}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-template>
</ng-container>